export enum DataTestId {
  menuBarAdminCommunityParishAdminDashboardLink = "menu-bar-admin-community-parish-admin-dashboard-link",
  menuBarAuthenticatedLink = "menu-bar-authenticated-link",
  menuBarUnauthenticatedLink = "menu-bar-unauthenticated-link",
  parishAdminDashboardDashboardTitle = "parish-admin-dashboard-dashboard-title",
  parishAdminDashboardSettingsGroupInfoTitle = "parish-admin-dashboard-settings-group-info-title",
  parishAdminDashboardSettingsPermissionsTitle = "parish-admin-dashboard-settings-permissions-title",
  loginMessage = "login-message",
}
